'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faArrowTrendUp } from '@fortawesome/pro-solid-svg-icons';
import useTableFilterSelections from 'src/hooks/filters/useTableFilterSelections';

interface ViewTrendButtonProps {
  location?: string;
}

const ViewTrendButton: React.FC<ViewTrendButtonProps> = ({
  location = 'lists',
}) => {
  const { columnIds, tempIsTrending, setIsTrending } =
    useTableFilterSelections(location);

  const isDisabled = columnIds.length === 0 || columnIds.length > 1;

  const handleIsTrending = () => {
    setIsTrending(!tempIsTrending);
  };

  return (
    <div className="flex flex-col gap-1">
      <span className="text-primary text-xs font-semibold h-5 mb-1"></span>
      <button
        type="button"
        className="h-10 px-4 py-2 bg-sky-50 rounded-3xl flex justify-start items-center gap-2.5 cursor-pointer border-0 transition-colors duration-200 disabled:bg-neutral-100 disabled:text-neutral-400 disabled:cursor-not-allowed hover:bg-sky-100 active:bg-sky-200 disabled:hover:bg-neutral-100 disabled:active:bg-neutral-100"
        onClick={handleIsTrending}
        disabled={isDisabled}
      >
        <div className="flex justify-start items-center gap-2">
          <Icon
            icon={faArrowTrendUp}
            className="text-sky-600 w-5 h-5 disabled:text-neutral-400"
          />
          <div className="justify-start text-sky-800 text-sm font-semibold font-['Inter'] leading-tight whitespace-nowrap">
            {tempIsTrending ? 'Close' : 'View'} Trend
          </div>
        </div>
      </button>
    </div>
  );
};

export default ViewTrendButton;
